import { MentionedDataframeName } from "@hex/common";
import { Placement } from "@popperjs/core";
import React from "react";

import { useScopeSelector } from "../../../../appsession-multiplayer/state-hooks/scopeStateHooks";
import { DataframeMentionDetails } from "../../../rich-text/plugins/MentionDetails";

import { MentionTooltip } from "./MentionTooltip";

interface DataframeMentionPopoverProps {
  dataframeName: MentionedDataframeName;
  children: React.ReactNode;
  placement?: Placement;
  maxWidthOverride?: number;
  isPlanned?: boolean;
}

export const DataframeMentionPopover = React.memo(
  function DataframeMentionPopover({
    children,
    dataframeName,
    isPlanned,
    maxWidthOverride,
    placement,
  }: DataframeMentionPopoverProps) {
    const dataframe = useScopeSelector({
      selector: (scope) => scope[dataframeName],
    });

    // For planned dataframes, show a tooltip even if not in scope yet
    const tooltip = dataframe ? (
      <DataframeMentionDetails
        mention={{
          mentionType: "dataframe",
          id: dataframe.name,
          name: dataframe.name as MentionedDataframeName,
          connectionId: null,
          columns: Object.keys(dataframe.dataFrameSchema?.columns ?? {}),
        }}
      />
    ) : isPlanned ? (
      <DataframeMentionDetails
        mention={{
          mentionType: "dataframe",
          id: dataframeName,
          name: dataframeName,
          connectionId: null,
          columns: [],
          isPlanned: true,
        }}
      />
    ) : null;

    return (
      <MentionTooltip
        content={tooltip}
        disabled={!tooltip}
        maxWidthOverride={maxWidthOverride}
        placement={placement}
      >
        {children}
      </MentionTooltip>
    );
  },
);
